import "./App.css";
import React from "react";
import { Routes, Route, Navigate, useSearchParams } from "react-router-dom";

import { Box, CssBaseline, ThemeProvider, Toolbar } from "@mui/material";

import theme from "./theme/theme";

import { useTenant } from "./hooks/useTenant";

//Pages
import Login from "./components/authentication/login";
import SignUp from "./components/authentication/signUp";
import Dashboard from "./components/dashboard";
import Forgot from "./components/authentication/forgot";
import ResetPassword from "./components/authentication/resetPassword";

//Components
import CustomAppBar from "./components/customAppBar";
import BookAppointment from "./components/guests/bookAppointment";
import ManageBooking from "./components/guests/manageBooking";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicOnlyRoute from "./components/PublicOnlyRoute";
import { useAuth } from "./context/AuthContext";

//Shared Modules
import LoadingScreen from "./shared_modules/loadingScreen";
import ErrorScreen from "./shared_modules/errorScreen";
import TenantNotFound from "./shared_modules/tenentNotFound";
import ErrorBoundary from "./shared_modules/ErrorBoundary";

function AppContent() {
  const { tenant, status, error } = useTenant();
  const { isAuthenticated, authLoading } = useAuth();
  const [searchParams] = useSearchParams();

  if (!authLoading && isAuthenticated) {
    const barberParam = searchParams.get("barber");
    const dest = barberParam
      ? `/dashboard/book?barber=${barberParam}`
      : "/dashboard";
    return <Navigate to={dest} replace />;
  }

  if (status === "loading") {
    return <LoadingScreen />;
  }

  if (status === "platform") {
    return <Box>platform screen</Box>;
  }

  if (status === "error") {
    return <ErrorScreen error={error} />;
  }

  if (status === "not_found") {
    return <TenantNotFound />;
  }

  if (status === "found") {
    return (
      <>
        <CustomAppBar tenant={tenant} showLoginButton={true} />
        <Toolbar />
        <Routes>
          <Route path="/booking" element={<ManageBooking />} />
          <Route path="/*" element={<BookAppointment />} />
        </Routes>
      </>
    );
  }

  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        <Routes>
          {/* Auth Pages — redirect to dashboard if already logged in */}
          <Route
            path="/login"
            element={
              <PublicOnlyRoute>
                <Login />
              </PublicOnlyRoute>
            }
          />
          <Route
            path="/signup"
            element={
              <PublicOnlyRoute>
                <SignUp />
              </PublicOnlyRoute>
            }
          />
          <Route
            path="/forgot"
            element={
              <PublicOnlyRoute>
                <Forgot />
              </PublicOnlyRoute>
            }
          />
          <Route
            path="/reset-password"
            element={
              <PublicOnlyRoute>
                <ResetPassword />
              </PublicOnlyRoute>
            }
          />

          {/* Dashboard — /* allows sub-paths like /dashboard/analytics */}
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          {/* Everything else goes through AppContent (guest booking flow) */}
          <Route path="/*" element={<AppContent />} />
        </Routes>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
